export class CommonConstants {

    public static readonly ROUTES = {
        CATALOG: '/catalog' as const,
        SERVICE_MATRIX: '/service-matrix' as const,
    }
    public static readonly CATALOG = "catalog" as const;
    public static readonly SERVICE_MATRIX = "service-matrix" as const;

    public static readonly ROOM = "room" as const;
    public static readonly DEPARTMENT = "department" as const;
    public static readonly PROGRAM = "program" as const;
    public static readonly PROJECT = "project" as const;
    public static readonly ROOM_CONTENT = "room-content" as const;
    public static readonly ID = "id" as const;

}